import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, Table, Dropdown, Image, Col, Row, Card, Badge, Spinner, Alert } from 'react-bootstrap'; // Ensure react-bootstrap is installed
import Select from 'react-select'; // Ensure react-select is installed
import "react-datepicker/dist/react-datepicker.css";
import { FaCreditCard, FaMoneyBillWave, FaUniversity, FaUsers } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { UserSubCreate, UserUpdateById, UserUpdateStatut, fetchUsersAll } from '../../../actions/request/UserRequest';
import { emptyImage, maxLengthLitte, profileRoleType } from '../../../utils/dataApi/dataFormApi';
import { toast } from 'react-toastify';
import { AccessDeleteAccompteyId } from '../../../actions/request/AccessRequest';
import { FETCH_CUSTOMER_SUCCESS, FETCH_PROPERTY_SUCCESS, FETCH_USER_SUCCESS, FETCH_VEHICLE_SUCCESS } from '../../../app/actions/actions';
import { getAndCheckLocalStorage } from '../../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../../utils/storage/localvalue';
import { MdAccountBox } from 'react-icons/md';
import { baseurl } from '../../../utils/url/baseurl';
import axios from 'axios';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { fetchRoleSubsAll } from '../../../actions/request/RoleSubRequest';
import { fetchCodePostalsAll } from '../../../actions/request/CodePostalRequest';
import { AssignSubAccountAtElementById, fetchReservationById, fetchReservationsAllByidUserId } from '../../../actions/request/ReservationRequest';
import { fetchMaintenancesAll } from '../../../actions/request/MaintenanceRequest';
import { fetchDamagesAll, fetchDamagesAllByUserId } from '../../../actions/request/DamageRequest';
import moment from 'moment';
import { ROUTES } from '../../../config/routingUrl';

const UserManagementPage = () => {

    const location   =  useLocation();

    const reservations = useSelector((state) => state.reservations.reservations);
    const maintenances = useSelector((state) => state.maintenances.maintenances);
    const damages = useSelector((state) => state.damages.damages);
    const insurances = useSelector((state) => state.insurances.insurances);
    const codepostals = useSelector((state) => state.codepostals.codepostals);
    const users = useSelector((state) => state.users.users);
    const rolesubs = useSelector((state) => state.rolesubs.rolesubs);
    const loadingUser = useSelector((state) => state.users.loadingUser);
    const [isShowPassword, setisShowPassword] = useState(false)
    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const [captchaToken, setCaptchaToken] = useState(null); // Stocke le token du captcha
    const [selectedLanguage, setSelectedLanguage] = useState("fr"); // Langue sélectionnée
    const keayrecaptcha = baseurl.ApiKeyRecaptcha;
    // State pour stocker la réservation actuellement sélectionnée
    const [selectedReservation, setSelectedReservation] = useState(null);




    const [formData, setFormData] = useState({
        _id: '',
        activateReservation: false,
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        codePostal: '',
        gender: 'Male',
        dateOfBirth: '',
        password: '',
        confirmPassword: '',
        profileType: 'Prestataire',
        role: 'INDIVIDUAL',
        companyName: '',
        contactName: '',
        companyAddress: '',
        numberTVA: '',
        licenceCommerciale: null,
        isPrestataire: true,
        roleSubAccount: {
            name: "",
            label: "",
            description: "",

        },
        roleId: "",
        parents: getAndCheckLocalStorage(localStorageKeys.userId)
    })


    const [formDataElement, setformDataElement] = useState({
        reservations: [],
        maintenances: [],
        damages: [],
        insurances: [],
    })
    const [formDataElement2, setformDataElement2] = useState({
        reservations: [],
        maintenances: [],
        damages: [],
        insurances: [],
    })


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const usersData = useSelector((state) => state.users.users);

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null)

    useEffect(() => {
        dispatch({ type: FETCH_USER_SUCCESS });
        dispatch({ type: FETCH_CUSTOMER_SUCCESS });
        dispatch(fetchCodePostalsAll())
        dispatch(fetchRoleSubsAll())
        if (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) {
            dispatch(fetchUsersAll(getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchReservationsAllByidUserId(getAndCheckLocalStorage(localStorageKeys.userId)))
            dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId)))
            dispatch(fetchDamagesAllByUserId(getAndCheckLocalStorage(localStorageKeys.userId)))
        }
        else if (
            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT
        ) {
            dispatch(fetchUsersAll());
        }
    }, [dispatch]);


   

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
    };


    const renderStatusBadge = (status) => {
        switch (status) {
            case 'Active':
                return <Badge bg="success">Actif</Badge>;
            case 'Blocked':
                return <Badge bg="danger">Bloqué</Badge>;
            default:
                return <Badge bg="secondary">{status}</Badge>;
        }
    };

    const [userItem, setuserItem] = useState(null);
    const [actionModal, setactionModal] = useState("")
    const [showModal, setshowModal] = useState(false);
    const [showModalAssignElement, setshowModalAssignElement] = useState(false);
    const [showModalSubAccount, setshowModalSubAccount] = useState(false);
    const [showModalDelete, setshowModalDelete] = useState(false);
    const handleShowModal = (action, objet) => {
        setshowModal(true);
        setactionModal(action)
        setuserItem(objet);
    }

    const handleShowModalDelete = (action, objet) => {
        setshowModalDelete(true);
        setactionModal(action)
        setuserItem(objet);
    }

    const handleShowModalSubAccount = () => {
        if (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) {
            setshowModalSubAccount(true);
        } else {
            toast.error("vousVous n'êtes pas autorisé", { position: "bottom-right" })
        }
    }
    const handleCloseModalSubAccount = () => {
        setshowModalSubAccount(false);
    }

    const handleCloseModal = () => { setshowModal(false); }

    const handleSubmit = () => {
        if (actionModal == "unclock") {
            dispatch(UserUpdateStatut(userItem?._id, toast))
            handleCloseModal();
        }
        else if (actionModal == "activated") {
            dispatch(UserUpdateStatut(userItem?._id, toast))
            handleCloseModal();
        }
        else if (actionModal == "unActiveAccompte") {
            dispatch(UserUpdateById(userItem?._id, formData, toast))
            handleCloseModal();
        }
        else if (actionModal == "ActiveAccompte") {
            dispatch(UserUpdateById(userItem?._id, formData, toast))
            handleCloseModal();
        }
        else if (actionModal == "delete") {
            dispatch(AccessDeleteAccompteyId(userItem?._id, toast))
            handleCloseModal();
        }
    }




    const [isActiveAccountReservation, setisActiveAccountReservation] = useState(false)
    const handleSubmitActiveAccountReservation = (e) => {
        e.preventDefault();
        // Submit logic here
    };



    // Information les sous compte
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        // Vérifier si le champ est un texte et limiter sa longueur à 100 caractères
        const newValue = type === 'text' && value.length > maxLengthLitte ? value.slice(0, 100) : value;

        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : newValue, // Appliquer la valeur limitée
        });

        // Optionnel : Afficher un message si la limite est atteinte
        if (type === 'text' && value.length > maxLengthLitte) {
            console.warn(`Le champ ${name || ""} ne peut pas dépasser ${maxLengthLitte} caractères.`);
            toast.error(`Le champ ${name || ""} ne peut pas dépasser ${maxLengthLitte} caractères.`)
        }
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData({
            ...formData,
            [name]: selectedOption ? selectedOption.value : '',
        });
    };




    // Fonction appelée lorsque le captcha est résolu
    const onVerify = (token) => {
        setCaptchaToken(token); // Stocke le token généré par hCaptcha
        // console.log("Captcha Token:", token);
    };
    const handleSubmitSubAccount = async (e) => {
        e.preventDefault();
        if (!formData.email || !formData.phone || !formData.codePostal || !formData.roleId) {
            toast.error("Veuillez remplir tous les champs obligatoires", { position: "bottom-right" });
            return;
        }

        if (!captchaToken) {
            toast.error("Veuillez valider le reCAPTCHA avant de continuer !", { position: "bottom-right" });
            return;
        }

        // if (!recaptchaValue) {
        //     toast.error("Veuillez valider le reCAPTCHA pour prouver que vous n'êtes pas un robot !", { position: "bottom-right" });
        //     return;
        // }

        // Détermine si l'utilisateur est un client ou un prestataire
        try {
            const response = await axios.post(
                `${baseurl.url}/api/validate-captcha`,
                { captchaToken },
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            const data = response.data;

            // if (data.success ) {
            //     toast.success("Captcha validé avec succès !", { position: "bottom-right" });

            if (formData.isPrestataire) {
                formData.profileType = "Prestataire";
                if (!formData.role) {
                    toast.error("Choix du type de profile obligatoire", { position: "bottom-right" })
                } else {
                    dispatch(UserSubCreate(getAndCheckLocalStorage(localStorageKeys.userId), formData.roleId, formData, toast));
                }
            } else {
                toast.error("Veillez indiquer le type de profile du compte s'il vous plais", { position: "bottom-right" })
            }
            // } else {
            //     toast.error(data.message || "La validation du captcha a échoué.", { position: "bottom-right" });
            // }
        } catch (error) {
            // console.error("Une errur s'est produite",);
            toast.error(error?.response?.data?.message || "Une erreur est survenue. Veuillez réessayer.", { position: "bottom-right" });
        }
    };

    const codePostalOptions = codepostals.map((code) => ({
        value: code._id,
        label: `+${code.indicatif} - (${code.country})`,
    })) || [];

    const rolesubOptions = rolesubs.map((code) => ({
        value: code._id,
        label: code.label,
        name: code.name,
        description: code.description,
        permissions: code.permissions,
    })) || [];

    const reservationOptions = reservations.map((code) => ({
        value: code._id,
        label: `${code.ordre} - ${moment(code.startDate).format("DD-MM-YYYY HH:MM")} au ${moment(code.startDate).format("DD-MM-YYYY HH:MM")}`,

        ordre: code.ordre,
        startDate: `${moment(code.startDate).format("DD-MM-YYYY HH:MM")}`,
        endDate: `${moment(code.endDate).format("DD-MM-YYYY HH:MM")}`,
        property: code.property,
        vehicle: code.vehicle,
        firstname: code.firstname,
        lastname: code.lastname,
        email: code.email,
        totalPrice: code.totalPrice,
        totalPriceReal: code.totalPriceReal,
        paymentMethod: code.paymentMethod,
        assignSubAccounts: code.assignSubAccounts
    }));


    const damagesOptions = damages.map((code) => ({
        value: code._id,
        label: `${code.ordre} - ${moment(code.startDate).format("DD-MM-YYYY HH:MM")} au ${moment(code.startDate).format("DD-MM-YYYY HH:MM")}`,
        startDate: `${moment(code.startDate).format("DD-MM-YYYY HH:MM")}`,
        endDate: `${moment(code.endDate).format("DD-MM-YYYY HH:MM")}`
    })) || [];

    const genderOptions = [
        { value: 'Male', label: 'Homme' },
        { value: 'Female', label: 'Femme' },
    ];

    const roleOptions = [
        { value: 'INDIVIDUAL', label: 'Particulier' },
        { value: 'COMPANY', label: 'Entreprise' },
    ];





    // Gestion du changement de sélection
    const handleSelectChangeElement = (selectedOption) => {
        if (selectedOption) {
            setSelectedReservation(selectedOption);
        } else {
            setSelectedReservation(null);
        }
    };

    // Ajouter une réservation au tableau
    // Ajouter une réservation au tableau
const handleAddReservation = () => {
    if (!selectedReservation) {
        toast.error("Veuillez sélectionner une réservation.", { position: "bottom-right" });
        return;
    }

    // Vérifier si la réservation existe déjà dans le tableau
    const isDuplicate = formDataElement.reservations.some(
        (reservation) => reservation._id === selectedReservation.value
    );

    if (isDuplicate) {
        toast.error("Cette réservation est déjà ajoutée.", { position: "bottom-right" });
        return;
    }

    // Récupérer les détails complets de la réservation sélectionnée
    const newReservation = reservationOptions.find(
        (option) => option.value === selectedReservation.value
    );

    if (!newReservation) {
        toast.error("Réservation introuvable.", { position: "bottom-right" });
        return;
    }

    // Ajouter la réservation au tableau
    setformDataElement2((prev) => ({
        ...prev,
        reservations: [...prev.reservations, newReservation],
    }));

    // Réinitialiser la sélection
    setSelectedReservation(null);
};

// Supprimer une réservation du tableau
const handleRemoveReservation = (reservationId) => {
    setformDataElement2((prev) => ({
        ...prev,
        reservations: prev.reservations.filter((r) => r._id !== reservationId),
    }));
};

    const handleSubmitAssignReservation = () => {
        if (!formData._id) {
            toast.error("Compte non sélectionner", { position: "bottom-right" })
            return;
        }
        if (formDataElement2.reservations && formDataElement2.reservations.length == 0) {
            toast.error("Veillez ajouter réservation s'il vous plais .", { position: "bottom-right" })
            return;
        }
        formDataElement2.reservations.map((item) => {
            dispatch(AssignSubAccountAtElementById(getAndCheckLocalStorage(localStorageKeys.userId), formData._id, item?.value))

        })
        // setshowModalAssignElement(false);
        const reservationsAssigns = reservationOptions.filter((reservation) =>
            reservation.assignSubAccounts.some((subAccount) => subAccount.toString() === formData._id)) || [];
        setformDataElement({ ...formDataElement, reservations: reservationsAssigns })
        setformDataElement2({ ...formDataElement, reservations: [] })
        setshowModalAssignElement(false)

    }

    return (
        <div className="container-fluid p-3 " style={{ marginBottom: "200px" }}>
            <Card>
                <Card.Header>
                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
                        <div>
                            <h3>
                                {getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ? <MdAccountBox /> : <FaUsers />}
                                {
                                    getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ?
                                        " Employés" : " Utilisateurs"
                                }
                            </h3>
                        </div>
                        <div className="">
                            {
                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER && (
                                    <div>
                                        <Button type="button" variant="primary" size="sm"
                                            onClick={() => {
                                                handleShowModalSubAccount();
                                            }}
                                        >
                                            + Ajouter sous agence
                                        </Button>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </Card.Header>
                <Card.Body style={{ minHeight: "500px" }}>
                    <Row>
                        {/*<Col md={3}>
                            <Form.Group controlId="search">
                                <Form.Control
                                    type="text"
                                    placeholder="Recherche"
                                    value={searchTerm}
                                    style={{ height: "40px" }}
                                    onChange={handleSearchChange}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group controlId="status">
                                <Select
                                    options={[
                                        { value: 'Active', label: 'Actif' },
                                        { value: 'Blocked', label: 'Bloqué' }
                                    ]}
                                    onChange={handleStatusChange}
                                    isClearable
                                    placeholder="Statut"
                                />
                            </Form.Group>
                        </Col> */}
                    </Row>

                    <Table striped bordered hover className="mt-5" responsive>
                        <thead>
                            <tr>
                                <th>Photo</th>
                                <th>Type</th>
                                <th>Nom de l{"'"}agence</th>
                                <th>Nom & Prénoms</th>
                                <th>Email</th>
                                <th>Services</th>
                                <th>Téléphone</th>
                                {
                                    (
                                        !getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) && (
                                        <th>Accompte (13%)</th>
                                    )
                                }
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {usersData?.map((user) => (
                                <tr key={user.id}>
                                    <td>
                                        {
                                            user.profilePicture ?
                                                <Image src={user.profilePicture} roundedCircle style={{ width: '50px', height: '50px' }} />
                                                :
                                                <Image src={emptyImage} roundedCircle style={{ width: '50px', height: '50px' }} />
                                        }
                                    </td>
                                    <td>
                                        {
                                            user && user.role && user.role == "COMPANY" ?
                                                "Entreprise" :
                                                "Particulier"
                                        }
                                    </td>
                                    <td>{user?.companyName || ""}</td>
                                    <td>{user?.firstname || ""} {user?.lastname || ""}</td>
                                    <td>{user?.email}</td>
                                    <td>
                                        {user.roleSubAccount && user?.roleSubAccount.name == "DRIVER" && (<span>Chauffeur</span>)}
                                        {user?.roleSubAccount && user?.roleSubAccount.name == "HOME" && (<span>Accueil</span>)}
                                        {user?.roleSubAccount && user?.roleSubAccount.name == "MAINTENANCE_TECHNICIAN" && (<span>Maintenance et technique</span>)}
                                        {user?.roleSubAccount && user?.roleSubAccount.name == "DAMAGE_HANDLER" && (<span>Service des domage</span>)}
                                        {user?.roleSubAccount && user?.roleSubAccount.name == "INSURANCE_AGENT" && (<span>Agence d{"'"}assurance</span>)}
                                        {user?.roleSubAccount && user?.roleSubAccount.name == "TREASURY_AGENT" && (<span>Responsable de la trésorie</span>)}
                                    </td>
                                    <td> {`+${user.codePostal.indicatif}`}  {user.phone}</td>
                                    {
                                        (
                                            !getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) && (
                                            <td>
                                                {
                                                    (
                                                        !getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) &&
                                                        user && user?.activateReservation && user?.activateReservation == true ?
                                                        <span className='text-success'>Oui</span> : <span className='text-danger'>Non</span>
                                                }
                                            </td>
                                        )
                                    }


                                    <td>{renderStatusBadge(user.status)}</td>
                                    <td>
                                        <Dropdown>
                                            <Dropdown.Toggle size='sm' variant="light">
                                                Action
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                {

                                                    (
                                                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER)
                                                    && (
                                                        <Dropdown.Item href="#assign" onClick={() => {
                                                            setFormData({
                                                                ...formData,
                                                                _id: user?._id || "",
                                                                firstname: user?.firstname || "",
                                                                lastname: user?.lastname || "",
                                                                email: user?.email || "",
                                                                roleSubAccount: user.roleSubAccount,
                                                            });
                                                            setformDataElement((prev) => ({
                                                                ...prev,
                                                                reservations: reservationOptions.filter((reservation) =>
                                                                    reservation.assignSubAccounts.some((subAccount) => subAccount.toString() === formData._id)
                                                                ),
                                                            }));
                                                            setshowModalAssignElement(true);

                                                            if (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) {
                                                                dispatch(fetchUsersAll(getAndCheckLocalStorage(localStorageKeys.userId)));
                                                                dispatch(fetchReservationsAllByidUserId(getAndCheckLocalStorage(localStorageKeys.userId)))
                                                                dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId)))
                                                                dispatch(fetchDamagesAllByUserId(getAndCheckLocalStorage(localStorageKeys.userId)))
                                                            }
                                                            else if (
                                                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                                                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                                                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT
                                                            ) {
                                                                dispatch(fetchUsersAll());
                                                            }

                                                        }}>Assignation</Dropdown.Item>
                                                    )
                                                }
                                                {
                                                    (
                                                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                                                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                                                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT
                                                    )
                                                    && (
                                                        <>
                                                            {
                                                                user && user?.activateReservation && user?.activateReservation == true ?
                                                                    <Dropdown.Item href="#unclock" onClick={() => { handleShowModal("unActiveAccompte", user); setFormData({ activateReservation: false }) }}>Bloquer accompte de réservation</Dropdown.Item>
                                                                    :
                                                                    <Dropdown.Item href="#activeAccountReservation" onClick={() => { handleShowModal("ActiveAccompte", user); setFormData({ activateReservation: true }) }}>Activer accompte  de réservation</Dropdown.Item>
                                                            }

                                                            {
                                                                user?.status && user?.status == "Active" ?
                                                                    <Dropdown.Item href="#unclock" onClick={() => { handleShowModal("unclock", user) }}>Bloquer compte</Dropdown.Item>
                                                                    :
                                                                    <Dropdown.Item href="#unclock" onClick={() => { handleShowModal("unclock", user) }}>Activer compte</Dropdown.Item>
                                                            }
                                                            {
                                                                user?.access && (
                                                                    <Dropdown.Item href="#delete" onClick={() => { handleShowModal("delete", user) }}>Supprimer compte</Dropdown.Item>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }



                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>


            <Modal show={showModal} onHide={handleCloseModal} size='md' centered>
                <Modal.Header>
                    <h5>
                        Confirmer votre action
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <div className='flex justify-content-center text-center' style={{ minHeight: "70px", width: "100%" }}>
                        <div>
                            <p>Êtes vous sur de vouloir <span className="font-weight-700">
                                {actionModal == "unclock" ? <span>{userItem?.status == "Active" ? "Bloquer ce compte " : " Activer ce compte " + userItem?.firstname + " " + userItem?.lastname} </span> : ""}
                                {actionModal == "activated" ? <span>{"Activer ce compte " + userItem?.firstname + " " + userItem?.lastname} </span> : ""}
                                {actionModal == "unActiveAccompte" ? <span>{"Activer l'accompte de la réservation pour cet compte " + userItem?.firstname + " " + userItem?.lastname} </span> : ""}
                                {actionModal == "ActiveAccompte" ? <span>{"Désactiver l'accompte de la réservation pour cet compte " + userItem?.firstname + " " + userItem?.lastname} </span> : ""}
                                {actionModal == "delete" && (<span>{"Supprimer cet compte " + userItem?.firstname + " " + userItem?.lastname} </span>)}
                            </span></p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <Button type="button" size="sm" variant="light" onClick={handleCloseModal}>Fermer</Button>

                    {
                        actionModal == "unclock" ?
                            <Button type="button" size="sm" variant="danger" onClick={handleSubmit}>Confirmer</Button>
                            :
                            actionModal == "activated" ?
                                <Button type="button" size="sm" variant="success" onClick={handleSubmit}>Confirmer</Button>
                                : ""
                    }

                    {
                        actionModal == "unActiveAccompte" ?
                            <Button type="button" size="sm" variant="danger" onClick={handleSubmit}>Confirmer</Button>
                            :
                            actionModal == "ActiveAccompte" ?
                                <Button type="button" size="sm" variant="success" onClick={handleSubmit}>Confirmer</Button>
                                : ""
                    }


                    {
                        actionModal == "delete" && (
                            <Button type="button" size="sm" variant="danger" onClick={handleSubmit}>confirmer</Button>
                        )
                    }

                </Modal.Footer>
            </Modal>





            {/*element subaccount*/}
            <Modal show={showModalSubAccount} onHide={handleCloseModalSubAccount} size='lg' centered>
                <Modal.Header>
                    <h5>
                        Ajouter nouveau sous compte à l{"'"}agence
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <div className='' style={{ minHeight: "70px", width: "100%" }}>
                        {/*<div>
                            <p className="text-center">
                                Êtes vous sur de vouloi ajouter un sous compte votre agence <span className="font-weight-700">
                                </span>
                            </p>
                        </div> */}
                        <div className="pt-3">
                            <Form>
                                {loadingUser ? (
                                    <div className="text-center">
                                        <Spinner animation="border" variant="primary" />
                                        <p>Chargement en cours...</p>
                                    </div>
                                ) : (
                                    <div style={{ width: "100%" }}>
                                        <div className=" row">

                                            <div className="col-md-12 form-group">
                                                <label className="text-dark">Nom <span className="text-danger">*</span></label>
                                                <input
                                                    style={{ height: "40px" }}
                                                    type={"text"}
                                                    className="form-control"
                                                    name={"firstname"}
                                                    value={formData.firstname}
                                                    onChange={handleChange}
                                                    required={true}
                                                />
                                            </div>
                                            <div className="col-md-12 form-group">
                                                <label className="text-dark">Prénoms <span className="text-danger">*</span></label>
                                                <input
                                                    style={{ height: "40px" }}
                                                    type={"text"}
                                                    className="form-control"
                                                    name={"lastname"}
                                                    value={formData.lastname}
                                                    onChange={handleChange}
                                                    required={true}
                                                />
                                            </div>
                                            <div className="col-md-12 form-group">
                                                <label className="text-dark">Email <span className="text-danger">*</span></label>
                                                <input
                                                    style={{ height: "40px" }}
                                                    type={"email"}
                                                    className="form-control"
                                                    name={"email"}
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required={true}
                                                />
                                            </div>

                                            <div className="col-md-5 form-group">
                                                <label className="text-dark">Indicatif <span className="text-danger">*</span></label>
                                                <Select className="text-dark" style={{ widht: "100%" }}
                                                    name="codePostal"
                                                    isClearable
                                                    options={codePostalOptions}
                                                    onChange={handleSelectChange}
                                                    placeholder="Choix"
                                                    required={true}
                                                />
                                            </div>

                                            <div className="col-md-7 form-group">
                                                <label className="text-dark">Téléphone <span className="text-danger">*</span></label>
                                                <input
                                                    style={{ height: "40px", with: "100%" }}
                                                    type={"number"}
                                                    className="form-control"
                                                    name={"phone"}
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    required={true}
                                                />
                                            </div>

                                            {formData.isPrestataire && (
                                                <div className="row col-md-12 ">
                                                    <div className="col-md-6 form-group">
                                                        <label className="text-dark">Indicatif <span className="text-danger">*</span></label>
                                                        <Select className="text-dark" style={{ widht: "100%" }}
                                                            name="roleId"
                                                            isClearable
                                                            options={rolesubOptions}
                                                            onChange={handleSelectChange}
                                                            placeholder="Choix"
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 form-group">
                                                        <label className="text-dark">Choix du type de profile</label>
                                                        <Select className="text-dark"
                                                            name="role"
                                                            isClearable
                                                            options={roleOptions}
                                                            onChange={handleSelectChange}
                                                            placeholder="Choix"
                                                        />
                                                    </div>
                                                </div>
                                            )}



                                            {/*<div className="col-md-12 form-group">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id="prestataireCheck"
                                                            label="Je souhaite devenir Prestataire ( pour les entreprise location )"
                                                            name="isPrestataire"
                                                            checked={formData.isPrestataire}
                                                            onChange={handleChange}
                                                            className="text-dark"
                                                        />
                                                    </div> */}

                                            <div className="col-md-12 form-group">
                                                <Form.Check
                                                    type="checkbox"
                                                    id="prestataireCheck"
                                                    label="Voir mot de passe"
                                                    name="isPrestataire"
                                                    checked={isShowPassword}
                                                    onChange={(e) => { setisShowPassword(e.target.checked) }}
                                                    className="text-dark"
                                                />
                                            </div>
                                        </div>

                                        {/* reCAPTCHA */}
                                        <div className="col-md-12 form-group">
                                            {/*<ReCAPTCHA
                                                        sitekey={keayrecaptcha} // Remplacez par votre clé reCAPTCHA
                                                        onChange={setRecaptchaValue}
                                                    />*/}
                                            <HCaptcha
                                                // sitekey="a4064d96-aed6-4a86-80a2-c1f2b434ace4" // Remplacez par votre clé de site hCaptcha
                                                sitekey={keayrecaptcha} // Remplacez par votre clé de site hCaptcha
                                                onVerify={onVerify} // Appelée lorsque le captcha est résolu
                                                hl={selectedLanguage}
                                            />
                                        </div>

                                        <div className="col-md-12 form-group">
                                            <Alert> Les mot de passe sera envoyé par defaut sur l{"'"}email renseignez</Alert>
                                        </div>

                                    </div>
                                )}
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" size="sm" variant="light" onClick={handleCloseModalSubAccount}>Fermer</Button>
                    {
                        loadingUser ?
                            <Button type="button" size="sm" variant="light"><Spinner variant="light" /></Button>

                            :
                            <Button variant="primary" size="sm" type="submit" onClick={handleSubmitSubAccount}>
                                <div className='text-center'>
                                    Ajouter
                                </div>
                            </Button>
                    }

                </Modal.Footer>
            </Modal >


            {/*modal d'assignation des réservation en question */}
            <Modal show={showModalAssignElement} onHide={() => { setshowModalAssignElement(false) }} centered size="xl">
                <Modal.Header><h5>Assignation réservations à <strong> {formData.firstname || ""} {formData.lastname || ""} </strong></h5></Modal.Header>
                <Modal.Body>
                    <div className='' style={{ minHeight: "70px", width: "100%" }}>
                        {/*<div>
                            <p className="text-center">
                                Êtes vous sur de vouloi ajouter un sous compte votre agence <span className="font-weight-700">
                                </span>
                            </p>
                        </div> */}
                        <div className="pt-3">
                            <Form>
                                {loadingUser ? (
                                    <div className="text-center">
                                        <Spinner animation="border" variant="primary" />
                                        <p>Chargement en cours...</p>
                                    </div>
                                ) : (
                                    <div style={{ width: "100%" }}>
                                        <div className=" row">


                                            {/* réservation listes assign */}
                                            <div className="row form-group mt-5">
                                                <div className="row col-md-6 form-group ">
                                                    <div className=""><h6>Nouvelle réservations</h6></div>
                                                    <div className="">
                                                        <label className="text-dark">Réservations</label>
                                                        <div className="d-flex" style={{ width: "100%" }}>
                                                            <div style={{ minWidth: "300px" }}>
                                                                <Select className="text-dark"
                                                                    name="reservations"
                                                                    isClearable
                                                                    options={formData.roleSubAccount.name === "DRIVER"
                                                                        ? reservationOptions.filter((item) => item.vehicle) // Filtre pour inclure uniquement les réservations avec un véhicule
                                                                        : formData.roleSubAccount.name === "HOME"
                                                                            ? reservationOptions.filter((item) => item.property) // Filtre pour inclure uniquement les réservations avec une propriété
                                                                            : reservationOptions // Si aucun des rôles ci-dessus, retourner toutes les options)
                                                                    }
                                                                    onChange={handleSelectChangeElement}
                                                                    placeholder="Choix"
                                                                />
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <Button size="sm" onClick={() => { handleAddReservation() }}>+ Ajouter</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className=" col-md-12 form-group">
                                                        {formDataElement2.reservations.length > 0 ? (
                                                            <Table striped bordered hover responsive className="mt-4">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Image</th>
                                                                        <th >N° Réservation</th>
                                                                        <th style={{ minWidth: "200px" }}>Client</th>
                                                                        <th style={{ minWidth: "200px" }}>Dates</th>
                                                                        {/*<th  style={{ minWidth:"200px" }}>Prix Total</th>
                                                                <th >Moyen de Paiement</th> */}
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {formDataElement2.reservations.map((reservation) => (
                                                                        <tr key={reservation._id}>
                                                                            <td>
                                                                                {reservation.vehicle?.images?.[0] ? (
                                                                                    <img
                                                                                        src={reservation.vehicle.images[0]}
                                                                                        alt="Vehicle"
                                                                                        style={{ width: "50px", height: "50px" }}
                                                                                        className="rounded"
                                                                                    />
                                                                                ) : reservation.property?.images?.[0] ? (
                                                                                    <img
                                                                                        src={reservation.property.images[0]}
                                                                                        alt="Property"
                                                                                        style={{ width: "50px", height: "50px" }}
                                                                                        className="rounded"
                                                                                    />
                                                                                ) : (
                                                                                    <span>Aucune image</span>
                                                                                )}
                                                                            </td>
                                                                            <td><span onClick={() => {
                                                                                if (reservation && reservation.vehicle) {
                                                                                    dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: reservation.vehicle });
                                                                                    dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                                                                                    navigate(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATION_VIEW}/${reservation.value}`)
                                                                                } else {
                                                                                    dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                                                                                    dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: reservation.property });
                                                                                    navigate(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATION_VIEW}/${reservation.value}`)
                                                                                }
                                                                            }}
                                                                                style={{ cursor: "pointer" }}
                                                                                className="text-decoration-underline">{reservation?.ordre}</span>
                                                                            </td>

                                                                            <td>
                                                                                {reservation.firstname} {reservation.lastname}
                                                                            </td>
                                                                            <td>
                                                                                {moment(reservation.startDate).format("DD-MM-YYYY HH:mm")} -{" "}
                                                                                {moment(reservation.endDate).format("DD-MM-YYYY HH:mm")}
                                                                            </td>
                                                                            {/*<td>
                                                                            {reservation.paymentMethod === "cash" && (<div className="d-flex flex flex-row"><FaMoneyBillWave size={24} /> <span> Espèces </span> </div>)}
                                                                            {reservation.paymentMethod === "bank" && (<div className="d-flex flex flex-row"><FaUniversity size={24} /> <span> Virement bancaire </span> </div>)}
                                                                            {reservation.paymentMethod === "card" && (<div className="d-flex flex flex-row"><FaCreditCard size={24} /> <span> Carte de crédit </span> </div>)}
                                                                        </td> */}
                                                                            <td>
                                                                                <Button
                                                                                    variant="danger"
                                                                                    size="sm"
                                                                                    onClick={() => handleRemoveReservation(reservation._id)}
                                                                                >
                                                                                    Supprimer
                                                                                </Button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        ) : (<p className="text-center mt-5"> Aucune réservations ajoutés</p>)}
                                                    </div>
                                                </div>
                                                <div className="col-md-6 form-group ">
                                                    <div><h6>Réservations Assigné</h6></div>
                                                    <div className="mt-5">
                                                        {formDataElement.reservations.length > 0 ? (
                                                            <Table striped bordered hover responsive className="mt-4">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Image</th>
                                                                        <th >N° Réservation</th>
                                                                        <th style={{ minWidth: "200px" }}>Client</th>
                                                                        <th style={{ minWidth: "200px" }}>Dates</th>
                                                                        {/*<th  style={{ minWidth:"200px" }}>Prix Total</th>
                                                                <th >Moyen de Paiement</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {formDataElement.reservations.map((reservation) => (
                                                                        <tr key={reservation._id}>
                                                                            <td>
                                                                                {reservation.vehicle?.images?.[0] ? (
                                                                                    <img
                                                                                        src={reservation.vehicle.images[0]}
                                                                                        alt="Vehicle"
                                                                                        style={{ width: "50px", height: "50px" }}
                                                                                        className="rounded"
                                                                                    />
                                                                                ) : reservation.property?.images?.[0] ? (
                                                                                    <img
                                                                                        src={reservation.property.images[0]}
                                                                                        alt="Property"
                                                                                        style={{ width: "50px", height: "50px" }}
                                                                                        className="rounded"
                                                                                    />
                                                                                ) : (
                                                                                    <span>Aucune image</span>
                                                                                )}
                                                                            </td>
                                                                            <td><span onClick={() => {
                                                                                if (reservation && reservation.vehicle) {
                                                                                    dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: reservation.vehicle });
                                                                                    dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                                                                                    navigate(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATION_VIEW}/${reservation.value}`)
                                                                                } else {
                                                                                    dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                                                                                    dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: reservation.property });
                                                                                    navigate(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATION_VIEW}/${reservation.value}`)
                                                                                }
                                                                            }}
                                                                                style={{ cursor: "pointer" }}
                                                                                className="text-decoration-underline">{reservation?.ordre}</span>
                                                                            </td>
                                                                            <td>
                                                                                {reservation.firstname} {reservation.lastname}
                                                                            </td>
                                                                            <td>
                                                                                {moment(reservation.startDate).format("DD-MM-YYYY HH:mm")} -{" "}
                                                                                {moment(reservation.endDate).format("DD-MM-YYYY HH:mm")}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        ) : (<p className="text-center mt-5"> Aucune réservations assignés</p>)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                )}

                            </Form>
                        </div>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" size="sm" variant="light" onClick={handleCloseModalSubAccount}>Fermer</Button>
                    {
                        loadingUser ?
                            <Button type="button" size="sm" variant="light"><Spinner variant="light" /></Button>

                            :
                            <Button variant="primary" size="sm" type="submit" onClick={handleSubmitAssignReservation}>
                                <div className='text-center'>
                                    Valider
                                </div>
                            </Button>
                    }
                </Modal.Footer>
            </Modal >

        </div >
    );
};

export default UserManagementPage;
